import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    CcReviewReviewProps,

    LoadProjectByIdOnly,
    LoadCcApprovalLevels,
    LoadCcResponses,
    LoadCcReviewReviewTypes,
    LoadCcReviewReviewItemById,
    LoadCcReviewReviewHistory,

    setCcApprovalLevelList,
    setCcResponseList,
    setCcModuleResponseList,
    setCcReviewReviewTypeList,
    setCcReviewReviewItemDetails,
    setCcReviewReviewItemHistory,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Details from "./details"
import History from "./history"

interface ReviewReviewAnswerProps extends CcReviewReviewProps {
    projectId: number
    fileId: number
}

const ReviewReviewAnswer = ({
    projectId,
    fileId,
    reviewItemId,
    revisionId,
}: ReviewReviewAnswerProps) => {
    const item = useSelector((state: StoreType) => state.ccReviewReview.itemDetails)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        LoadProjectByIdOnly(projectId).then((project) => (
            Promise.all([
                // review approval levels
                LoadCcApprovalLevels(project.accountId, project.id, 2)
                .then((res) => {
                    dispatch(setCcApprovalLevelList(res.levelList))
                }),
                // review (review) responses
                LoadCcResponses(project.accountId, project.id, 3)
                .then((res) => {
                    dispatch(setCcResponseList(res.responseList))
                    dispatch(setCcModuleResponseList({ 3: res.responseIds }))
                }),
                // responsible responses
                LoadCcResponses(project.accountId, project.id, 0)
                .then((res) => {
                    dispatch(setCcResponseList(res.responseList))
                    dispatch(setCcModuleResponseList({ 0: res.responseIds }))
                }),
                // review types
                LoadCcReviewReviewTypes(project.accountId, project.id)
                .then((res) => {
                    dispatch(setCcReviewReviewTypeList(res.typeList))
                }),
                LoadCcReviewReviewItemById(reviewItemId, fileId).then((res) => {
                    dispatch(setCcReviewReviewItemDetails(res))
                }),
                LoadCcReviewReviewHistory(reviewItemId, revisionId).then((res) => {
                    dispatch(setCcReviewReviewItemHistory(res))
                }),
            ])
        )).then(() => {
            setLoadState(IDLE)
        })
    }, [])

    if (!item) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editAnswer}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }

                <Details />
                <History />
            </PageContent>
        </Container>
    )
}
export default ReviewReviewAnswer
